// extracted by mini-css-extract-plugin
export default {"summary":"MealSummary_summary__ET0it"};